const DEFAULT_STATE = {
  sites: [2, 52, 139, 133, 24, 25, 22, 127, 39, 13],
  periods: [],
  dates: [],
  periodType: "",
  globalStats: {},
};

export default {
  namespaced: true,
  state: {
    ...DEFAULT_STATE,
  },
  getters: {
    getSites: (state) => state.sites,
    getPeriods: (state) => state.periods,
    getPeriodType: (state) => state.periodType,
    getDates: (state) => state.dates,
    getGlobalStats: (state) => state.globalStats,
  },
  mutations: {
    initState(state) {
      for (const [key, value] of Object.entries(DEFAULT_STATE)) {
        state[key] = value;
      }
    },
    setGlobalStats(state, payload) {
      state.globalStats = payload;
    },
    setSites(state, payload) {
      state.sites = payload;
    },
    setPeriods(state, payload) {
      state.periods = payload;
    },
    setPeriodType(state, payload) {
      state.periodType = payload;
    },
    setDates(state, payload) {
      state.dates = payload;
    },
  },
  actions: {
    initState({ commit }) {
      commit("initState");
    },
    updateGlobalStats(context, payload) {
      context.commit("setGlobalStats", payload);
    },
    updateSites(context, payload) {
      context.commit("setSites", payload);
    },
    setPeriods(context, payload) {
      context.commit("setPeriods", payload);
    },
    updatePeriodType({ commit }, payload) {
      commit("setPeriodType", payload);
    },
    updateDates({ commit }, payload) {
      commit("setDates", payload);
    },
  },
};
